import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchCommunitydetail } from "../services/Communitydetail";
import { API_BASE } from "../api/apiConfig";

const Communitydetailbanner = () => {
  const { id } = useParams();
  const [Communitydetaildata, setCommunitydetaildata] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadBanner = async () => {
      const res = await fetchCommunitydetail(decodeURIComponent(id));

      if (res?.data) {
         setCommunitydetaildata(res.data);
      }
      setLoading(false);
    };

    loadBanner();
  }, [id]);

  if (loading) return <p className="text-center py-10">Loading...</p>;
  if (!Communitydetaildata) return <p className="text-center py-10">No Data found</p>;

  return (
     <section className="relative h-64 md:h-80 lg:h-96 w-full overflow-hidden">
        <img
          alt={Communitydetaildata?.city}
          decoding="async"
          data-nimg="fill"
          className="object-cover"
          style={{
            position: 'absolute',
            height: '100%',
            width: '100%',
            inset: 0,
            color: 'transparent',
          }}
          src={
            Communitydetaildata?.banner_image
              ? `${API_BASE}${Communitydetaildata.banner_image}`
              : `${API_BASE}default.jpg`
          }
          onError={(e) => {
            e.currentTarget.src = `${API_BASE}default.jpg`;
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-800/60 to-slate-700/20"></div>
        {/* Breadcrumb */}
        <div className="absolute top-4 md:top-6 left-4 right-4 z-10">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-2 text-white/90">
              <a
                className="text-sm md:text-base hover:underline font-medium hover:text-white transition-colors"
                href="/community"
              >
                Communities
              </a>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-chevron-right h-4 w-4 md:h-5 md:w-5"
              >
                <path d="m9 18 6-6-6-6" />
              </svg>
              <span className="text-sm md:text-base font-medium text-white">{Communitydetaildata.city}</span>
            </div>
          </div>
        </div>
        {/* Main Header Content */}
        <div className="absolute inset-0 flex flex-col justify-center md:justify-end p-4 md:p-10">
          <div className="max-w-7xl mx-auto w-full text-center md:text-left">
            <h1
              className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-3 md:mb-2 [text-shadow:0_2px_8px_rgba(0,0,0,0.9)]"
            >
              {Communitydetaildata?.city} Travel Community
            </h1>
            <p
              className="text-base md:text-base text-white/95 max-w-2xl mx-auto md:mx-0 [text-shadow:0_1px_4px_rgba(0,0,0,0.8)] mb-6 md:mb-3 leading-relaxed"
            >
              Connect with fellow travelers in {Communitydetaildata?.city} to explore the city of dreams and beyond.
            </p>
            <a href={`/CommunityJoin/${Communitydetaildata.id}`}>
              <button
                className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 py-2 bg-primary text-white hover:bg-primary/90 text-base md:text-sm h-12 md:h-9 px-6 md:px-4 rounded-lg shadow-lg hover:shadow-xl transition-all duration-200"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-calendar mr-2 h-5 w-4"
                >
                  <path d="M8 2v4" />
                  <path d="M16 2v4" />
                  <rect width="18" height="18" x="3" y="4" rx="2" />
                  <path d="M3 10h18" />
                </svg>
                Join Community
              </button>
            </a>
          </div>
        </div>
      </section>

 
  );
};

export default Communitydetailbanner;
